import { render, staticRenderFns } from "./Overview24hBl.vue?vue&type=template&id=526b135a&scoped=true&"
import script from "./Overview24hBl.vue?vue&type=script&lang=js&"
export * from "./Overview24hBl.vue?vue&type=script&lang=js&"
import style0 from "./Overview24hBl.vue?vue&type=style&index=0&id=526b135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b135a",
  null
  
)

/* custom blocks */
import block0 from "./Overview24hBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports